import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { IPageDataV3 } from '@df/catalog/cms/cms-model.interface';
import { UiComponent } from '@df/ui/ui.component';
import { NICmsContentField } from '@icms/core/content/interfaces/icms-content-field.interfaces';
import { ICmsPageType } from '@icms/core/content/page/icms-page-type.decorator';
import { LocalPage } from '../../../page.decorator';
import { CmsBlogContentPostListingViewComponent } from '../../content/post-listing/cms-blog-content-post-listing.component';
import { BLOG_TAB } from '../root-view/cms-blog-page-root-view.component';
export namespace NBlogCategoryPageType {
    export const typeId = 'blog-category';

    /**
     * Top blog page url
     */
    export const blogOrigin = '/blog';
    export interface ITypeData {
        /**
         * Pull topCopy and name from parent page
         */
        useParent: boolean;
        /**
         * Copy belop page title
         */
        topCopy: string;
        /**
         * If true then tag will redirect location
         * otherwise they will act as a filter without changes
         */
        tagRedirect: string;
    }
}

@ICmsPageType({
    id: NBlogCategoryPageType.typeId,
    title: 'Blog category',
    fields: [
        {
            type: NICmsContentField.EFieldType.toggle,
            key: 'typeData.useParent',
            title: 'Use parent category content',
            default: true,
            tab: BLOG_TAB
        },
        {
            type: NICmsContentField.EFieldType.text,
            key: 'typeData.topCopy',
            title: 'Top copy',
            canShow: d => !d.useParent,
            tab: BLOG_TAB
        },
        {
            type: NICmsContentField.EFieldType.toggle,
            key: 'typeData.tagRedirect',
            title: 'Redirect location on tag change',
            default: true,
            tab: BLOG_TAB
        }
    ]
})
@Component({
    selector: 'cms-blog-page-category-view',
    templateUrl: './cms-blog-page-category-view.html',
    standalone: true,
    imports: [CmsBlogContentPostListingViewComponent],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CmsBlogPageCategoryViewComponent extends UiComponent {
    @Input()
    model?: LocalPage<IPageDataV3>;
}
